module.exports = __webpack_public_path__ + "images/top-skus-15c48788.svg";